import { PawPrint, Send } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 8: Wyślij znajomemu - bezpośredni, osobisty apel
 */
export const InstagramStoryShare8 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      {/* Background image */}
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Top accent */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "8px",
          background: "#4E8A6E",
          zIndex: 2,
        }}
      />

      {/* Content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "200px 80px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Send icon */}
        <div
          style={{
            background: "rgba(78, 138, 110, 0.12)",
            borderRadius: "50%",
            width: "140px",
            height: "140px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "56px",
          }}
        >
          <Send style={{ width: "68px", height: "68px", color: "#4E8A6E" }} />
        </div>

        {/* Main headline */}
        <h1
          style={{
            fontSize: "78px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 40px",
            textAlign: "center",
            lineHeight: 1.2,
          }}
        >
          Wyślij to
          <br />
          jednej osobie
        </h1>

        {/* Subtitle */}
        <p
          style={{
            fontSize: "46px",
            fontWeight: 600,
            color: "#4A7A5E",
            margin: "0 0 56px",
            textAlign: "center",
            lineHeight: 1.45,
            maxWidth: "880px",
          }}
        >
          Tej, która kocha zwierzęta.
          <br />
          Tej, która chciałaby pomóc.
        </p>

        {/* Quote card */}
        <div
          style={{
            background: "rgba(255,255,255,0.95)",
            borderRadius: "32px",
            padding: "44px 56px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
            marginBottom: "56px",
            maxWidth: "880px",
          }}
        >
          <p
            style={{
              fontSize: "38px",
              fontWeight: 700,
              color: "#2D5A3D",
              margin: 0,
              textAlign: "center",
              lineHeight: 1.45,
            }}
          >
            Jedno udostępnienie = jedno
            <br />
            schronisko bliżej pomocy
          </p>
        </div>

        {/* Secondary text */}
        <p
          style={{
            fontSize: "36px",
            fontWeight: 600,
            color: "#5A8A70",
            margin: "0 0 56px",
            textAlign: "center",
            lineHeight: 1.5,
          }}
        >
          Udostępnij na story
          <br />
          lub wyślij link w wiadomości
        </p>

        {/* CTA pill */}
        <div
          style={{
            background: "rgba(78, 138, 110, 0.12)",
            borderRadius: "50px",
            padding: "28px 56px",
          }}
        >
          <p
            style={{
              fontSize: "40px",
              fontWeight: 700,
              color: "#3D6B52",
              margin: 0,
              textAlign: "center",
            }}
          >
            Udostępnianie też pomaga 💚
          </p>
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          padding: "0 80px 100px",
          display: "flex",
          justifyContent: "center",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "14px",
              width: "52px",
              height: "52px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>
            gdzieschronisko.pl
          </span>
        </div>
      </div>
    </div>
  );
};
